import { render, staticRenderFns } from "./UserGradeApprovalNew.vue?vue&type=template&id=39827850&scoped=true"
import script from "./UserGradeApprovalNew.vue?vue&type=script&lang=js"
export * from "./UserGradeApprovalNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39827850",
  null
  
)

export default component.exports